"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRootElement = void 0;
const createElement_1 = require("./utils/dom/createElement");
function createRootElement() {
    document.body.innerHTML = '';
    const rootDiv = (0, createElement_1.createElement)('<div class="over-wrapper" style="position: relative; overflow: hidden; "></div>');
    document.body.append(rootDiv);
    return rootDiv;
}
exports.createRootElement = createRootElement;
